// Supermove
import {gql} from '@supermove/graphql';
import {useForm, useFormMutation} from '@supermove/hooks';

// App
import ToggleStageIsArchivedForm from '@shared/modules/Project/forms/ToggleStageIsArchivedForm';

const useToggleStageIsArchivedMutation = ({
  form: formValues,
  onSuccess,
  onError,
}: {
  form: {
    stageId: number;
    isArchived: boolean;
  };
  onSuccess: (response: any) => void;
  onError: (errors: any) => void;
}) => {
  const form = useForm({
    initialValues: {
      form: ToggleStageIsArchivedForm.toForm(formValues),
    },
  });

  const {submitting, handleSubmit} = useFormMutation({
    form,
    mutation: useToggleStageIsArchivedMutation.mutation,
    variables: {
      toggleStageIsArchivedForm: ToggleStageIsArchivedForm.toMutation(form.values.form),
    },
    onSuccess,
    onError,
  });

  return {
    form,
    submitting,
    handleSubmit,
  };
};

// --------------------------------------------------
// GraphQL Mutation Definition
// --------------------------------------------------
useToggleStageIsArchivedMutation.mutation = gql`
  mutation ToggleStageIsArchivedMutation($toggleStageIsArchivedForm: ToggleStageIsArchivedForm!) {
    response: toggleStageIsArchived(toggleStageIsArchivedForm: $toggleStageIsArchivedForm) {
      errors {
        field
        message
      }
      stage {
        id
        archivedAt
      }
    }
  }
`;

export default useToggleStageIsArchivedMutation;
